import { combineReducers, createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import cvDataReducer from './reducers/cv.reducer';

const rootReducer = combineReducers({cv: cvDataReducer});

let composeEnhancers = compose;

export default () => {
  return createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
};



// WEBPACK FOOTER //
// ./src/store/configureStore.ts